import { StatsSelectors, useTranslation } from '@web_opxp/features';
import { MouseEvent, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Dispatch, Action } from 'redux';
import { PRIVACY_HIGHSCORE } from '../../base/constants';
import { getUserPrivacySubpageUrl } from '../../base/historyService';
import ConfirmationDialog from '../../challenge/ConfirmationDialog';
import { IState } from '../../store/state';
import { HighscoresActions } from '../slice';
import ChallengeHighscores from './ChallengeHighscores';
import ChallengeHighscoresFooter from './ChallengeHighscoresFooter';

export default function ChallengeHighscoresWrapper() {
  const { language, t } = useTranslation();
  const dispatch = useDispatch<Dispatch<Action<string>>>();
  const agreement = !!useSelector((state: IState) => StatsSelectors.getStatBooleanValueById(state, PRIVACY_HIGHSCORE));
  const [showConfirmation, setShowConfirmation] = useState(false);
  const privacyUrl = getUserPrivacySubpageUrl(language);
  const openConfirmation = (e: MouseEvent) => {
    e.preventDefault();
    setShowConfirmation(true);
  };
  const handleConfirmationGiven = () => {
    dispatch(HighscoresActions.confirmParticipation());
    setShowConfirmation(false);
  };
  return (
    <>
      {agreement ? (
        <ChallengeHighscores />
      ) : (
        <div className="no-data">
          <a onClick={openConfirmation} href={privacyUrl}>
            {t('ChallengeLeaderboard.PrivacyHint')}
          </a>
        </div>
      )}
      <ChallengeHighscoresFooter />
      <ConfirmationDialog
        show={showConfirmation}
        onCancel={() => setShowConfirmation(false)}
        onConfirm={handleConfirmationGiven}
      />
    </>
  );
}
